import styled from 'styled-components';

export const Grid = styled.div`
    display: grid;
    width: ${props => (props.isMobile ? '100%' : '50%')};
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-auto-flow: column;
`;
